import React, { Fragment} from 'react';
import Breadcrumb from "../common/breadcrumb";

const ComunicadosDetalle = (props) => {
	const urlPage = "https://terancomunicados.com/comunicados/nota/informacion-relevante-en-materia-fiscal-10-de-marzo-2025/";
	const title = "Información Relevante en Materia Fiscal 10 de Marzo 2025";

	return (
		<Fragment>
			<Breadcrumb title="Página principal" parent="Comunicados" />
			<div className="container-fluid">
				<div className="breadcumb-area comunicados mb-5" style={{backgroundImage: 'url(https://placehold.jp/1700x450.png)', padding: '70px 0px', backgroundColor: '#ffffff', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat', backgroundSize: 'cover'}}>
					<div className="container">
						<div className="row">
							<div className="col-12">
								<div className="breadcumb-wrap text-center">
									<h2>Comunicados</h2>
									<ul>
										<li className="d-inline-block"><a href="/comunicados/inicio" style={{textDecoration: 'none', color: '#000'}}>Comunicados</a></li>
										<li className="d-inline-block mx-1">-</li>
										<li className="d-inline-block"><a href="/comunicados/detalle" style={{ textDecoration: 'none', color: '#000' }}>Detalle</a></li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="blog-details-area mt-5">
					<div className="container">
						<div className="row">
							<div className="col-12">
								<div className="blog-wrapper">

									<div className="comunicados-bn" style={{ position: 'relative', marginBottom: '45px'}}>
										<img
											src="https://placehold.jp/1110x579.png"
											alt={title}
										/>
										<h2 className="comunicados-titulo" style={{position: 'absolute', top: '50%', transform: 'translateY(-50%)', left: 0, color: '#fff', display: 'inline-block', padding: '0 20px', width: '100%', textAlign: 'center', marginBottom: 0}}>{title}</h2>
									</div>

									<div className="blog-meta">
										<ul>
											<li>28 Enero, 2026</li>
										</ul>
										<h3>{title}</h3>
									</div>

									<iframe
										src="https://comunicados.joseluisteran.com/comunicados/45082/revista-legal-cloud-enero-2025.pdf"
										width="100%"
										height="800"
										title="Documento Federal"
										className="mb-5 mt-4"
									/>

									<iframe
										src="https://comunicados.joseluisteran.com/comunicados/45082/in-federal-cdmx-impuesto-a-fortunas-040325.pdf"
										width="100%"
										height="800"
										title="Revista Legal"
										className="mb-5 mt-4"
									/>

									<br />

									<p>Fuente de Información:
										<a href="https://lopezdoriga.com/..." target="_blank" rel="noreferrer"> López-Dóriga Digital</a>
									</p>

									<div className="d-flex align-items-center" style={{ borderBottom: '1px solid #e5e5e5', borderTop: '1px solid #e5e5e5', padding: '20px 0'}}>
										<h6 style={{ fontWeight: '700'}}>Etiquetas</h6>
										<ul>
											<li style={{display: 'inline-block', lineHeight: '33px', backgroundColor: '#f1f1f1', margin: '10px 5px',  position: 'relative', padding: '5px 15px',  display: 'block', fontWeight: '600'}}><a style={{ textDecoration: 'none', color: '#222', fontSize: '14px'}} href="/comunicados">COMUNICADOS</a></li>
										</ul>
									</div>

									{/* Social Share */}
									<div className="share-rs">
										<h6>Compartir:</h6>
										<ul className="socil-media d-flex">
											<li style={{ height: '50px', width: '172px', display: 'block', lineHeight: '50px', textAlign: 'center', background: '#3673b7', borderRadius: '5px', marginRight: '15px' }}>
												<a style={{ color: '#fff', fontSize: '16px', textDecoration: 'none' }} href={`https://www.facebook.com/sharer/sharer.php?u=${urlPage}`} target="_blank" rel="noreferrer">
													<i className="fa fa-facebook"></i>
												</a>
											</li>
											<li style={{ height: '50px', width: '172px', display: 'block', lineHeight: '50px', textAlign: 'center', background: '#1da1f2', borderRadius: '5px', marginRight: '15px' }}>
												<a style={{ color: '#fff', fontSize: '16px', textDecoration: 'none' }} href={`https://www.facebook.com/sharer/sharer.php?u=${urlPage}`} target="_blank" rel="noreferrer">
													<i class="fa fa-twitter"></i>
												</a>
											</li>
											<li style={{ height: '50px', width: '172px', display: 'block', lineHeight: '50px', textAlign: 'center', background: '#0077b5', borderRadius: '5px' }}>
												<a style={{ color: '#fff', fontSize: '16px', textDecoration: 'none' }} href={`https://www.facebook.com/sharer/sharer.php?u=${urlPage}`} target="_blank" rel="noreferrer">
													<i class="fa fa-linkedin"></i>
												</a>
											</li>
										</ul>
									</div>

								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Fragment>
	);
}

export default ComunicadosDetalle;